import React, { forwardRef, useRef } from 'react';
import { Flex, Input, Text } from '@keyslabor/shared/ui';
import DatePickerBase from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import {
  CalendarArrowLeft,
  CalendarArrowRight,
} from '@keyslabor/shared/assets/svgComponents';
import { useCalendarConfig } from '@/hooks/useCalendarConfig.ts';

// TODO: Remove any
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const CustomInput = forwardRef((props: any, ref) => {
  return <Input ref={ref} height="40px" borderColor="#7F87B6" {...props} />;
});

export default function DatePicker({
  name,
  value,
  label,
  maxDate,
  required,
  onChange,
  onFocus,
  onBlur,
  // TODO: Remove any
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
}: any) {
  const inputRef = useRef(null);
  const calendarConfig = useCalendarConfig();

  return (
    // todo shared Input Label component
    <Flex flexDirection="column">
      {label ? (
        <Flex>
          <Text fontSize="14px" fontWeight="500" mb="6px">
            {label}
          </Text>
          {required ? (
            <Text color="#EB5757" ml="2px">
              *
            </Text>
          ) : null}
        </Flex>
      ) : null}

      <DatePickerBase
        name={name}
        value={value}
        selected={value}
        onChange={onChange}
        placeholder=""
        suffixIcon={null}
        prevIcon={<CalendarArrowLeft />}
        nextIcon={<CalendarArrowRight />}
        calendarClassName="date-picker-calendar"
        calendarStartDay={calendarConfig.firstDayOffset}
        maxDate={maxDate}
        customInput={<CustomInput inputRef={inputRef} />}
      />
    </Flex>
  );
}
